import './Footer.module.css';

const Footer = () => {
  return <footer>&copy; 2021 Kaori Era</footer>;
};

export default Footer;
